<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>

<div class="row" style="direction: rtl;display: flex !important;">
    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 padding0">
        <input class="search_box" name="search_all" [(ngModel)]="search_all" (keyup)="check_access(4,1,'',1,2)"
            placeholder="جستجو..." autocomplete="off" style="width:100%">
    </div>
    <div class="col-xl-8 col-lg-8 col-md-7 col-sm-8 col-xs-12 padding0">
        <div [ngStyle]="{'direction' : lang == 2 ? 'ltr' : 'rtl'}" class="service_pager">
            <span>
                <button (click)='insert()' [disabled]='new_status' *ngIf="lang == 1" class="new1">جديد</button>
                <button (click)='open_detaile(0,3,0)' *ngIf="lang == 1" class="search1">جستجو</button>
                <button (click)='open_contract()' *ngIf="lang == 1" class="search1">پیش فرض متن قرارداد</button>
                <a id="download" href="{{ site }}/export/{{ export_code }}.xlsx" *ngIf="show_excel == true">
                    <button [ngClass]="{en_navigation_number:lang==2}">
                        <span *ngIf="lang == 2">Excel</span>
                        <span *ngIf="lang == 1">خروجی اکسل</span>
                    </button>
                </a>
                <button (click)="check_access(4,4,0,1,1)" [disabled]='next_status'><i
                        class="fas fa-fast-forward"></i></button>
                <button (click)="check_access(4,2,0,1,1)" [disabled]='next_status'><i
                        class="fas fa-forward"></i></button>
                <button (click)="check_access(4,3,0,1,1)" [disabled]='pre_status'><i
                        class="fas fa-backward"></i></button>
                <button (click)="check_access(4,5,0,1,1)" [disabled]='pre_status'><i
                        class="fas fa-fast-backward"></i></button>
                <div class='navigation' [ngClass]="{en_navigation_number:lang==2}"><span> {{ page_number_first }}
                    </span><span>-</span><span> {{ page_number_second }} </span><span> of </span><span>
                        {{ count_total }} </span>
                </div>
            </span>
        </div>
    </div>
</div>

<div class="content-body control-content-body" [ngClass]="{content_body_en:lang==2}"
    style='overflow-x:auto;direction:rtl;' (window:resize)="change_resize()">
    <mat-table [dataSource]="dataSource" style='min-width:100%' class='table-scroll mat_table_fa_without_scroll pe1'
        [ngClass]="{mat_table_en_without_scroll:lang==2,en1:lang == 2}"
        [ngStyle]="{'direction': lang == 2 ? 'ltr' : 'rtl' }">
        <ng-container matColumnDef="row">
            <mat-header-cell *matHeaderCellDef style='max-width:40px'>
                <span *ngIf="lang == 1">ردیف</span>
                <span *ngIf="lang == 2">#</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:40px'>{{ i + page_number_first }}</mat-cell>
        </ng-container>


        <ng-container matColumnDef="customer">
            <mat-header-cell *matHeaderCellDef style="min-width:180px">
                <span *ngIf="lang == 1">نام مشتری</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_ckd_id)"
                style="min-width:180px">
                <div class="right">{{ x.customer_title }}
                </div>

            </mat-cell>
        </ng-container>


        <ng-container matColumnDef="cellphone">
            <mat-header-cell *matHeaderCellDef style="max-width:110px">
                <span *ngIf="lang == 1">شماره همراه</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_ckd_id)"
                style="max-width:110px">
                {{ x.customer_cellphone }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef style="max-width:90px">
                <span *ngIf="lang == 1">تاریخ سند</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_ckd_id)"
                style="max-width:90px">{{ x.site_ckd_date }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="count_all">
            <mat-header-cell *matHeaderCellDef style="max-width:90px">
                <span *ngIf="lang == 1">تعداد کالاها</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_ckd_id)"
                style="max-width:90px">{{ x.count_all | number }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="sum">
            <mat-header-cell *matHeaderCellDef style="min-width:180px">
                <span *ngIf="lang == 1">
                    قیمت کل به تومان
                    بدون تخفیف
                </span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_ckd_id)"
                style="min-width:180px">{{ x.sum_all | number }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="discount">
            <mat-header-cell *matHeaderCellDef style="max-width:130px">
                <span *ngIf="lang == 1"> تخفیف به تومان</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_ckd_id)"
                style="max-width:130px">{{ x.discount_all | number }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="sum_with_discount">
            <mat-header-cell *matHeaderCellDef style="min-width:180px">
                <span *ngIf="lang == 1">قیمت به تومان با تخفیف</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_ckd_id)"
                style="min-width:180px;">{{ x.sum_with_discount | number }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="tax">
            <mat-header-cell *matHeaderCellDef style="max-width:130px">
                <span *ngIf="lang == 1"> ارزش افزوده به تومان</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_ckd_id)"
                style="max-width:130px">{{ x.tax | number }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="sum_final">
            <mat-header-cell *matHeaderCellDef style="max-width:130px">
                <span *ngIf="lang == 1"> قیمت نهایی به تومان</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_ckd_id)"
                style="max-width:130px;background-color:#8df178;">{{ x.sum_final | number }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="sort">
            <mat-header-cell *matHeaderCellDef [hidden]="true">
                <span *ngIf="lang == 1">ترتیب</span>
                <span *ngIf="lang == 2">Sort</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" [hidden]="true" (click)="open_detaile(i,2,x.site_ckd_id)">{{
                x.site_ckd_sort }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef style="max-width:90px">
                <span *ngIf="lang == 1"> وضعیت </span>
                <span *ngIf="lang == 2"> Status</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_ckd_id)"
                style="max-width:90px">
                <span>{{ x.ckd_status_title }}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef style="max-width:50px">
                <span *ngIf="lang == 1"> شناسه </span>
                <span *ngIf="lang == 2">Id</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_ckd_id)"
                style="max-width:50px">{{ x.site_ckd_id }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="operation">
            <mat-header-cell *matHeaderCellDef style='max-width:100px'>
                <span *ngIf="lang == 1"> عملیات </span>
                <span *ngIf="lang == 2">Operation</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:100px'>
                <span style="font-size: 1rem;"
                    (click)="get_menu1(x.site_ckd_id,x.user_sex_title,x.customer_title,x.customer_cellphone,x.site_ckd_token,x.site_ckd_seleton_id)"
                    [matMenuTriggerFor]="menu"><i class="fas fa-info-circle icon"></i></span>
                <span (click)='open_detaile(i,2,x.site_ckd_id)'><i class="fas fa-desktop icon"></i></span>
                <span class="operation-icon" (click)="check_access(3,0,x.site_ckd_id,0,1)"><i
                        class="far fa-trash-alt icon" style='margin:0px 4px;'></i></span>
            </mat-cell>
        </ng-container>

        <mat-menu #menu="matMenu" class="ckd-mat-menu-panel" xPosition="before">
            <table class="table table-bordered" (click)="$event.stopPropagation()">
                <tr>
                    <td>
                        <a [href]="'/ckd-letter/'+token" target="_blank">
                            نامه
                        </a>
                    </td>
                </tr>
                <tr>
                    <td>
                        <a [href]="'/ckd-list/'+token" target="_blank">
                            متریال
                        </a>
                    </td>
                </tr>
                <tr>
                    <td>
                        <a [href]="'/tr-ckd/'+token" target="_blank">
                            پیش فاکتور داخلی
                        </a>
                    </td>
                </tr>
                <tr>
                    <td>
                        <a [href]="'/invoice2/'+token" target="_blank">
                            پیش فاکتور مشتری
                        </a>
                    </td>
                </tr>
                <tr>
                    <td>
                        <a (click)="open_invoice(id,seleton_id)" class="cursor">
                            جزئیات
                        </a>
                    </td>
                </tr>


                <tr>
                    <td class="cursor">
                        <span (click)="send_sms(id,sex_title,customer_title,customer_cellphone,token)">
                            ارسال پیامک
                        </span>
                    </td>
                </tr>
            </table>
        </mat-menu>

        <mat-header-row class="mat-header-row-dialog" *matHeaderRowDef="displayedColumns" color="primary">
        </mat-header-row>
        <mat-row class="mat-header-row-dialog" *matRowDef="let row;columns:displayedColumns;let i = index"
            (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row"
            [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
            class="cursor"></mat-row>

    </mat-table>

    <div class="row" class="preview1" [hidden]="count_total > 0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div>
                <img src="../../../assets/images/preview.png">
            </div>
            <div class="preview2">{{ no_record }}</div>
        </div>
    </div>
</div>